// extracted by mini-css-extract-plugin
export default {"topAd_box":"index_topAd_box_MAUVf","topAd":"index_topAd_FFPyY","search_bar":"index_search_bar_KVXjs","devide":"index_devide_oG0V1"};